import React from 'react';
import { LI } from '../../core-components/li';
import { Link } from '../../core-components/link';
import { UL } from '../../core-components/ul';
import { Box, BoxProps } from '../../next-components/box';
import { LazyImage } from '../lazyload/LazyImage';
import { Placeholder as LazyImagePlaceholder } from '../lazyload/Placeholder';
import { Typography } from '../Typography';
export type AuthorBlockRelatedArticles = {
  title: string;
  src: string;
};
export type AuthorBlockProps = Omit<BoxProps, 'value'> & {
  value: {
    src: string;
    breed: string;
    name: string;
    reviewedBy?: string;
    publishedDate?: string;
    editedDate?: string;
    relatedArticles?: AuthorBlockRelatedArticles[];
  };
};

/**
 * Deprecated: According to the design we will now have a new version (see ./next directory)
 * of this one and on the next major release of this package, this one
 * will not be supported anymore.
 *
 * Take note that this is used in the Health Articles. Make sure to collaborate first
 * with the design team making the major release
 */
export const AuthorBlock = ({
  value: {
    src,
    name,
    breed,
    reviewedBy,
    publishedDate,
    editedDate,
    relatedArticles
  },
  ...rest
}: AuthorBlockProps) => <Box display="grid" gridGap="24px" {...rest} data-sentry-element="Box" data-sentry-component="AuthorBlock" data-sentry-source-file="AuthorBlock.tsx">
    <Box display="grid" gridTemplateColumns={['72px 1fr']} gridGap="16px" data-sentry-element="Box" data-sentry-source-file="AuthorBlock.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="AuthorBlock.tsx">
        <LazyImage src={src} height="72px" width="72px" bg="none" overflow="unset" alt={`${name} avatar`} imageProps={{
        width: '72px',
        borderRadius: '50%'
      }} placeholder={<LazyImagePlaceholder width="72px" borderRadius="50%" />} data-sentry-element="LazyImage" data-sentry-source-file="AuthorBlock.tsx" />
      </Box>
      <Box data-sentry-element="Box" data-sentry-source-file="AuthorBlock.tsx">
        <Typography m={0} fontSize="16px" maxWidth={['270px', '100%']} data-sentry-element="Typography" data-sentry-source-file="AuthorBlock.tsx">
          Written by&nbsp;
          {breed && <>
              {`a ${breed} lover`}
&nbsp;
            </>}
          <Box as="b" data-sentry-element="Box" data-sentry-source-file="AuthorBlock.tsx">
            {name}
          </Box>
        </Typography>
        <Typography m={0} fontSize="16px" data-sentry-element="Typography" data-sentry-source-file="AuthorBlock.tsx">
          Veterinary reviewed by:
          {' '}
          {reviewedBy}
        </Typography>
        <Typography m={0} fontSize="16px" data-sentry-element="Typography" data-sentry-source-file="AuthorBlock.tsx">
          {`Published: ${publishedDate}, edited: ${editedDate}`}
        </Typography>
      </Box>
    </Box>
    {!!relatedArticles.length && <Box display="grid" gridTemplateColumns={['72px 1fr']} gridGap="16px">
        <Box width="1px" height="100%" border="1px solid #979797" mx="auto" />
        <Box>
          <Typography m={0} fontSize="14px" fontWeight="bold" textTransform="uppercase">
            {`More articles by ${name}`}
          </Typography>
          <UL p={0} my="16px" style={{
        listStyleType: 'none'
      }}>
            {relatedArticles.map(relatedArticle => <LI key={relatedArticle.title} py="8px">
                <Link href={relatedArticle.src} fontSize="16px" fontWeight="bold" color="wagGreen" fontFamily="muli">
                  {relatedArticle.title}
                </Link>
              </LI>)}
          </UL>
        </Box>
      </Box>}
  </Box>;